
import HomeFilter from "@home/pages/studio/home/components/Filter";
import StudioMetricCardRank from "@home/pages/studio/home/components/StudioMetricCardRank";
import StudioMetricCardTrend from "@home/pages/studio/home/components/StudioMetricCardTrend";
import RollingRetentionCard from "@home/pages/studio/home/components/RollingRetentionCard";
import RollingRetentionService from "@home/pages/studio/home/components/RollingRetentionService";
import CommonLogWrap from "@home/pages/studio/components/CommonLogWrap";
import HomeFooter from "@home/pages/studio/home/components/HomeFooter";
import StudioMetricCardService from "@home/pages/studio/home/components/StudioMetricCardService";
import CardState from "@home/pages/studio/home/components/CardState";
import StudioMetricCardRankCountry from "@home/pages/studio/home/components/StudioMetricCardRankCountry";
import RevenueCard from "@home/pages/studio/home/components/RevenueCard";
import TechlandYtdRevenueCard from "@home/pages/studio/home/components/TechlandYtdRevenueCard";
import TechlandYtdRevenueCardSlot from "@home/pages/studio/home/components/TechlandYtdRevenueCard/TechlandYtdRevenueCardSlot";
import TechlandYtdCardMetricsService from "@home/pages/studio/home/components/TechlandYtdCardMetricsService";
import ShowTimeService from "@home/pages/studio/home/components/ShowTimeService";
import StudioTrendCardService from "@home/pages/studio/home/components/StudioTrendCardService";
import TechlandMultiMetricTrendCard from "@home/pages/studio/home/components/TechlandMultiMetricTrendCard";
import OverallKPIService from "@home/pages/studio/home/components/OverallKPIService";
import RevenueTrendPanel from "@home/pages/studio/home/components/RevenueTrendPanel";
import KIPTableCard from "@home/pages/studio/home/components/KIPTableCard";
import KpiTrendService from "@home/pages/studio/home/components/KpiTrendService";
import KPIFilter from "@home/pages/studio/home/components/KPIFilter";
import KIPTableCardService from "@home/pages/studio/home/components/KIPTableCardService";
import StudioMetricCardTrendAndRank from "@home/pages/studio/home/components/StudioMetricCardTrendAndRank";
import KPIChangeLog from "@home/pages/studio/home/components/KPIChangeLog";
import BIIntelligenceMetricService from "@home/pages/studio/home/components/BIIntelligenceMetricService";
import AISummaryCard from "@home/pages/studio/home/components/AISummaryCard";
import BITItle from "@home/pages/studio/home/components/BITItle";
import BIOpinionsMetricService from "@home/pages/studio/home/components/BIOpinionsMetricService";
import NoticeAlert from "@/pages/dashboard/components/NoticeAlert";
import IntelligenceReports from "@home/pages/studio/home/components/IntelligenceReports";
import CasualOverviewWrap from "@home/pages/studio/casualHub/CasualOverview/components/CasualOverviewWrap";
import PerformanceDataTableWrap from "@home/pages/studio/home/components/PerformanceDataTableWrap";
import StudioSteamAllReviewsWrap from "@home/pages/studio/home/components/TechlandSteamAllReviewsWrap";
import StudioCardTrendService from "@home/pages/studio/home/components/StudioCardTrendService";
import StudioCardHorBar from "@home/pages/studio/home/components/StudioCardHorBar";
import StudioRegionDistributionBlock from "@home/pages/studio/home/components/StudioRegionDistributionBlock";
import StudioBundlePerformanceBlock from "@home/pages/studio/home/components/StudioBundlePerformanceBlock";
import SpecialDealsSwitch from "@home/pages/studio/home/components/SpecialDealsSwitch";
import SpecialDealsService from "@home/pages/studio/home/components/SpecialDealsService";

export default {
  HomeFilter,
  StudioMetricCardRank,
  StudioMetricCardRankCountry,
  StudioMetricCardTrend,
  RollingRetentionCard,
  RollingRetentionService,
  CommonLogWrap,
  HomeFooter,
  StudioMetricCardService,
  CardState,
  RevenueCard,
  TechlandYtdRevenueCard,
  TechlandYtdRevenueCardSlot,
  TechlandYtdCardMetricsService,
  ShowTimeService,
  StudioTrendCardService,
  TechlandMultiMetricTrendCard,
  OverallKPIService,
  KpiTrendService,
  RevenueTrendPanel,
  KIPTableCard,
  KPIFilter,
  KIPTableCardService,
  StudioMetricCardTrendAndRank,
  KPIChangeLog,
  BIIntelligenceMetricService,
  AISummaryCard,
  BITItle,
  BIOpinionsMetricService,
  NoticeAlert,
  IntelligenceReports,
  CasualOverviewWrap,
  PerformanceDataTableWrap,
  StudioSteamAllReviewsWrap,
  StudioCardTrendService,
  StudioCardHorBar,
  StudioRegionDistributionBlock,
  StudioBundlePerformanceBlock,
  SpecialDealsSwitch,
  SpecialDealsService,
};
